import _regeneratorRuntime from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _objectSpread from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _createForOfIteratorHelper from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import _asyncToGenerator from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import e from "../../request.js";
import t from "../../core/Error.js";
import { throwIfAbortError as r } from "../../core/promiseUtils.js";
import { normalize as o, removeFile as s } from "../../core/urlUtils.js";
import n from "../../portal/Portal.js";
import l from "../../portal/PortalQueryParams.js";
import { enableWebStyleForceWOSR as a } from "../../support/featureFlags.js";
var f = {};

function u(_x, _x2) {
  return _u.apply(this, arguments);
}

function _u() {
  _u = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(e, t) {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return b(e, t);

          case 3:
            _context.t0 = _context.sent.data;
            _context.t1 = s(e);
            _context.t2 = e;
            return _context.abrupt("return", {
              data: _context.t0,
              baseUrl: _context.t1,
              styleUrl: _context.t2
            });

          case 9:
            _context.prev = 9;
            _context.t3 = _context["catch"](0);
            return _context.abrupt("return", (r(_context.t3), null));

          case 12:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 9]]);
  }));
  return _u.apply(this, arguments);
}

function i(e, t, r) {
  var o = t && t.portal || n.getDefault();
  var s;
  var l = "".concat(o.url, " - ").concat(o.user && o.user.username, " - ").concat(e);
  return f[l] || (f[l] = y(e, o, r).then(function (e) {
    return s = e, e.fetchData();
  }).then(function (t) {
    return {
      data: t,
      baseUrl: s.itemUrl,
      styleName: e
    };
  })), f[l];
}

function y(e, r, o) {
  return r.load(o).then(function () {
    var t = new l({
      disableExtraQuery: !0,
      query: "owner:".concat(w, " AND type:").concat(h, " AND typekeywords:\"").concat(e, "\"")
    });
    return r.queryItems(t, o);
  }).then(function (_ref) {
    var r = _ref.results;
    var s = null;
    var n = e.toLowerCase();

    if (r && Array.isArray(r)) {
      var _iterator = _createForOfIteratorHelper(r),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _e = _step.value;

          if (_e.typeKeywords.some(function (e) {
            return e.toLowerCase() === n;
          }) && _e.type === h && _e.owner === w) {
            s = _e;
            break;
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }

    if (!s) throw new t("symbolstyleutils:style-not-found", "The style '".concat(e, "' could not be found"), {
      styleName: e
    });
    return s.load(o);
  });
}

function m(e, r, o) {
  return e.styleUrl ? u(e.styleUrl, o) : e.styleName ? i(e.styleName, r, o) : Promise.reject(new t("symbolstyleutils:style-url-and-name-missing", "Either styleUrl or styleName is required to resolve a style"));
}

function c(e) {
  return null === e || "CIMSymbolReference" === e.type ? e : {
    type: "CIMSymbolReference",
    symbol: e
  };
}

function p(e, t) {
  if ("cimRef" === t) return e.cimRef;

  if (e.formatInfos && !a()) {
    var _iterator2 = _createForOfIteratorHelper(e.formatInfos),
        _step2;

    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var _r = _step2.value;
        if ("gltf" === _r.type) return _r.href;
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
  }

  return e.webRef;
}

function d(e) {
  var _iterator3 = _createForOfIteratorHelper(e.typeKeywords),
      _step3;

  try {
    for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
      var _t = _step3.value;
      if (/^Esri.*Style$/.test(_t) && "Esri Style" !== _t) return _t;
    }
  } catch (err) {
    _iterator3.e(err);
  } finally {
    _iterator3.f();
  }
}

function b(t, r) {
  var s = _objectSpread({
    responseType: "json",
    query: {
      f: "json"
    }
  }, r);

  return e(o(t), s);
}

var w = "esri_en",
    h = "Style",
    j = "https://cdn.arcgis.com/sharing/rest/content/items/220936cc6ed342c9937abd8f180e7d1e/resources/styles/cim/{SymbolName}.json?f=json";
export { j as Style2DUrlTemplate, m as fetchStyle, c as makeCIMSymbolRef, b as requestJSON, d as styleNameFromItem, p as symbolUrlFromStyleItem };